import axios from "axios";
import React, { useEffect, useState } from "react";
import "./addbanner.scss";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/loading/Loading";

function Addbanner() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState();
  const [add, setAdd] = useState({
    name: "",
    note: "",
  });
  const sizeImage = 1000000;

  const [image, setImage] = useState("");

  const addBanner = async () => {
    const data = new FormData();
    data.append("name", add.name);
    data.append("note", add.note);
    data.append("image", image);
    if (image.size > sizeImage) {
      setTitle("Image size is too Big, Maximum size 1MB");
      setModalShow(true);
    } else if (add.name !== "" && add.note !== "" && image !== "") {
      setLoading(true);
      await axios.post("https://mobile.amospa.com/banners", data);
      setLoading(false);
      setTitle("Success Add Banner");
      setModalShow(true);
    } else {
      setTitle("fill in all forms");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/setting/banner/");
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-add-banner">
                <div className="header-add-banner">
                  <h5 className="m-0">Create new banner</h5>
                </div>
                <div className="form-add-banner">
                  <div className="wrapper-data">
                    <label>
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      onChange={(e) => setAdd({ ...add, name: e.target.value })}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="note"
                      onChange={(e) => setAdd({ ...add, note: e.target.value })}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Image (Max 1MB)<span className="text-danger">*</span>{" "}
                      <span className="text-danger ms-2">
                        {image && image.size > sizeImage
                          ? "Image size is too Big"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="File"
                      name="image"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                  <button className="text-white" onClick={() => addBanner()}>
                    Create new banner
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Isi Semua Form" &&
          title !== "Image size is too Big, Maximum size 1MB"
            ? handleNext
            : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Addbanner;
